import { Component, inject } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { I18nProviderInjectionToken } from './i18n/i18n.scope';
import { provideI18nScope } from '@pct-ng/transloco';
import { FooterComponent } from './footer.component';
import { fadeInEnter } from '@pct-ng/animation';
import { environment } from '@szte-griffin/environment';
import { AUTH_SERVICE_INJECTION_TOKEN } from './auth-service-injection-token';

@Component({
  selector: 'szg-core-auth-ui-login',
  imports: [FooterComponent, TranslocoPipe, MatFabButton],
  templateUrl: './login.component.html',
  animations: [fadeInEnter],
  providers: [provideI18nScope(I18nProviderInjectionToken)],
  host: {
    class: 'flex flex-col background-color min-h-screen items-center justify-center',
    '[@fadeInEnter]': '',
  },
})
export class LoginComponent {
  protected readonly i18nScope = inject<string>(I18nProviderInjectionToken);
  readonly #authService = inject(AUTH_SERVICE_INJECTION_TOKEN);
  protected readonly secondaryLogo = environment.logo.secondary;

  protected onSubmit(): void {
    this.#authService.login();
  }
}
